import { Typography, TypographyProps } from "@mui/material";
import { LinkProps, Link as RouterLink } from "react-router-dom";
import {
  SENT_MESSAGE_EMOJI_FONT_SIZE,
  splitByEmoji,
} from "../../../helpers/emoji";

// regex to split out full URLs (http(s):// or www.) and to test each piece
const urlRegexGlobal = /((?:https?:\/\/|www\.)\S+)/gi;
const urlRegex = /^(?:https?:\/\/|www\.)\S+$/i;

export interface Props extends TypographyProps {
  text: string;
  LinkProps?: Omit<LinkProps, "to">;
  enlargeEmojis?: boolean;
}

const renderPlainText = (text: string, enlargeEmojis: boolean) => {
  if (!enlargeEmojis) return text;

  return splitByEmoji(text).map((part, index) =>
    part.type === "emoji" ? (
      <span key={index} style={{ fontSize: SENT_MESSAGE_EMOJI_FONT_SIZE }}>
        {part.value}
      </span>
    ) : (
      part.value
    ),
  );
};

const LinkifyTypography = ({
  text,
  LinkProps = {},
  enlargeEmojis = false,
  ...typographyProps
}: Props) => {
  // split the text into chunks, keeping the full URL strings as separate items
  const parts = text.split(urlRegexGlobal);

  const children = parts.map((part, i) =>
    urlRegex.test(part) ? (
      <RouterLink
        key={i}
        to={part.startsWith("www.") ? `https://${part}` : part}
        target="_blank"
        rel="noopener noreferrer"
        style={{ textDecoration: "underline" }}
        {...LinkProps}
      >
        {part}
      </RouterLink>
    ) : (
      <span key={i}>{renderPlainText(part, enlargeEmojis)}</span>
    ),
  );

  return <Typography {...typographyProps}>{children}</Typography>;
};

export default LinkifyTypography;
